import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Col, Glyphicon, Row} from "react-bootstrap";
import {Link} from 'react-router-dom';
import {loadGeneralEnum} from '../actions/enums';
import {countParties, loadParties} from '../actions/parties';
import {showModal} from "../actions/modal";
import {resetPage, showMessage} from '../actions';
import {defaultState} from '../reducers/paginate';
import Parties from '../components/party/Parties';
import {breadcrumbs} from "../utils";

class PartiesPage extends Component {

	constructor(props) {
		super(props);

		this.handleFetchData = this.handleFetchData.bind(this);
		this.handleFetchEnums = this.handleFetchEnums.bind(this);
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps) {
	}

	componentWillUnmount() {
		this.props.resetPage();
	}

	handleFetchEnums(enums, filter = {}) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				this.props.loadGeneralEnum(enums[i], filter)
			}
		}
	}

	handleFetchData(filter) {
		this.props.loadParties(filter);
		this.props.countParties(filter);
	}

	render() {
		const {page, enums, session} = this.props;

		return (
			<div>
				<Row>
					<Col xs={8}>
						{breadcrumbs([{title: 'Osoby'}])}
					</Col>
					<Col xs={4}>
						<Link to={{pathname: "/vencitele/novy"}} className="btn btn-success pull-right"><Glyphicon glyph="plus"/> Nový venčitel</Link>
					</Col>
				</Row>
				<Parties {...page} enums={enums} session={session}
					onFetchEnums={this.handleFetchEnums}
					onFetchData={this.handleFetchData}
					onShowModal={this.props.showModal}
					onShowMessage={this.props.showMessage}
				/>
			</div>
		)
	}
}

PartiesPage.propTypes = {
	page: PropTypes.object,
	enums: PropTypes.object,
	loadGeneralEnum: PropTypes.func.isRequired,
	loadParties: PropTypes.func.isRequired,
	countParties: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	resetPage: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired,
	showModal: PropTypes.func.isRequired
};


const mapStateToProps = (state, ownProps) => {
	const {
		pagination: {parties},
		enums,
		session
	} = state;

	const page = parties[0] || defaultState;

	return {
		page,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadGeneralEnum,
	loadParties,
	countParties,
	showMessage,
	resetPage,
	showModal
})(PartiesPage)



// WEBPACK FOOTER //
// ./src/containers/PartiesPage.js